export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./cashback.vue?vue&type=template&id=4e9d608e"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/bonuses/cashback.vue?vue&type=template&id=4e9d608e
// module id = jYgR
// module chunks = 0